import { ValidateUserForm } from '@monorepo/shared-lib';
import Logo from 'assets/images/generateTAX-logo.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
import routes from 'routes';

interface ValidateUserFormProps {
  loading: boolean;
  userExists: boolean | null;
  activate: (password: string) => void;
  resend: (email: string) => void;
  resetPassword?: boolean;
}

/** Thin GT wrapper around shared ValidateUserForm */
export const ValidateUserFormLocal: React.FC<ValidateUserFormProps> = ({
  loading,
  userExists,
  activate,
  resend,
  resetPassword,
}) => {
  const { t } = useTranslation();

  return (
    <ValidateUserForm
      loading={loading}
      userExists={userExists}
      activate={activate}
      resend={resend}
      resetPassword={resetPassword}
      logo={Logo}
      logoLinkTo={routes.login}
      labels={{
        logoAriaLabel: t('login.logo-aria-label'),
        almostThere: t('signup.almost-there'),
        changePasswordTitle: t('forgot-password.change-your-password'),
        fillInDetailsStep: t('signup.fillInDetailsStep'),
        emailVerifiedStep: t('signup.emailVerifiedStep'),
        setPasswordStep: t('signup.setPasswordStep'),
        createPassword: t('signup.create-password'),
        passwordDescription: t('signup.password-description'),
        password: t('signup.password'),
        repeatPassword: t('signup.repeatPassword'),
        pleaseEnterPassword: t('signup.pleaseEnterPassword'),
        pleaseConfirmPassword: t('signup.pleaseConfirmPassword'),
        passwordDoNotMatch: t('signup.passwordDoNotMatch'),
        passwordMin12: t('other.password-min-12-characters'),
        submit: t('common.submit'),
        invalidActivationTitle: t('signup.invalid-activation-title'),
        invalidActivationDescription: t(
          'signup.invalid-activation-description',
        ),
        invalidResetTitle: t('forgot-password.invalid-reset-title'),
        invalidResetDescription: t(
          'forgot-password.invalid-reset-description',
        ),
        emailAddress: t('signup.email-address'),
        requiredField: t('common.required-field'),
        invalidEmail: t('signup.invalid-email'),
        resendActivation: t('signup.resend'),
        resendReset: t('forgot-password.resend'),
      }}
    />
  );
};

export { ValidateUserFormLocal as ValidateUserForm };
